var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('checkbox',{class:{'is-invalid': _vm.error},attrs:{"checkbox":{
			txt: _vm.label,
			isChecked: _vm.value
		}},nativeOn:{"click":function($event){return _vm.$emit('input', !_vm.value)}}}),_vm._v(" "),_c('span',{class:[
			'styled-form__error',
			'styled-form__error--checkbox',
			{'is-visible': _vm.error}
		]},[_vm._v(_vm._s(_vm.error))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }